<template>
	<div class="s-flex s-flex-col s-shadow sm:s-rounded-lg s-overflow-hidden">
		<div class="s-overflow-x-auto">
			<div class="s-align-middle s-inline-block s-min-w-full">
				<table class="s-min-w-full s-border-collapse" cellspacing="0" cellpadding="0">
					<!-- Header -->
					<thead class="">
						<slot name="header">
							<tr class="">
								<th
									v-for="(item, i) in header"
									:key="i"
									class="s-px-6 s-py-3 s-border-b s-border-gray-200 s-bg-gray-50 s-text-left s-text-xs s-leading-4 s-font-medium s-text-gray-500 s-uppercase s-tracking-wider"
								>
									{{ item.label }}
								</th>
							</tr>
						</slot>
					</thead>

					<!-- Body -->
					<tbody class="s-bg-white">
						<template v-for="(item, index) in list">
							<slot :item="item" :index="index" />
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		header: {
			type: Array,
			default: () => [],
		},

		list: {
			type: Array,
			default: () => [],
		},
	},
}
</script>
